import { Icon, Text, Tooltip } from '@factorialco/deprecated-design-system'

import { typeFilterLabelTranslations } from 'modules/payroll_bundle/lib/Incidences/dynamicTranslations'

export interface IncidenceTypeStats {
  sick?: number
  bank?: number
  name?: number
  gender?: number
  hiring?: number
  address?: number
  parental?: number
  contract?: number
  workplace?: number
  residence?: number
  nationality?: number
  termination?: number
  custom_leave?: number
  identification?: number
  manual_incidence?: number
}

interface Props {
  open: boolean
  stats: IncidenceTypeStats | undefined
  toggle: (value: boolean) => () => void
}

const StatsTooltip = ({ stats, toggle, open }: Props) => {
  if (!stats) return null

  return (
    <Tooltip.ItemList toggle={toggle} attachment="top center" open={open} size="normal">
      <Icon.Medium icon="info-circle-line" color="tangerine1000" />
      <>
        {Object.entries(stats).map(([key, total]) => {
          const incidenceType = typeFilterLabelTranslations(key)

          return <Text.Normal key={key}>{`${incidenceType} (${total})`}</Text.Normal>
        })}
      </>
    </Tooltip.ItemList>
  )
}

export default StatsTooltip
